import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterText'
})
export class FilterTextPipe implements PipeTransform {
  transform<T>(items: T[], args: string[]): T[] {
    if (!items.length) return [];
    if (args[0] === null) {
      return items;
    }
    const searchText = args[0].toLowerCase();
    return items.filter((item: any) => {
      return item[args[1]].toLowerCase().includes(searchText);
    });
  }
}
